import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';

import DeviceGuidData, { IDeviceGuidData } from "../../models/device/DeviceGuidData";
import { IConnectFormData } from "../../models/device/ConnectFormData";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { IDeviceFetchData } from "../../models/device/DeviceFetchData";
import i18next from "i18next";


class ConnectionActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.DEVICE_ENDPOINT);
    }


    async getKey() {
        try {
            const request = new ApiRequest("/Key", "", null, i18next.t("Internal server error!"));
            const result = await this.api.get(request);
            const payload = this.convertResponseData(result.data);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.DEVICE_GET_GUID,
                payload: {
                    deviceGuidData: payload
                }
            });
        } catch (error) {
            await triggerNotifications.error(error);
        }
    }


    async connect(data: IConnectFormData, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/connect", requestId, data, i18next.t("Device successfully Connected."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.DEVICE_CONNECTION_DATA,
                payload: {
                    connectedDeviceData: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async fetch(data: IDeviceFetchData, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/connect/fetch", requestId, data, i18next.t("Device successfully Connected."));
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.DEVICE_FETCH_DATA,
                payload: {
                    deviceFetchData: result.data
                }
            });
        } catch (error) {
            throw error;
        }
    }

    private convertResponseData(data: any): IDeviceGuidData {
        return new DeviceGuidData(data.id, data.key);
    }

}

const connectionActions = new ConnectionActions();
export default connectionActions;